<!-- Start Breadcrumb -->
<div class="breadcrumb-area bg-cover shadow theme-hard text-center text-light" style="background-image: url(assets/img/banner/8.jpg);">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1>Privacy Policy</h1>
        <ul class="breadcrumb">
          <li><a routerLink="/"><i class="fas fa-home"></i> Home</a></li>
          <li>Policies</li>
          <li>Privacy Policy</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- End Breadcrumb -->

<div class="services-details-area overflow-hidden default-padding">
  <div class="container">
    <div class="services-details-items">
      <div class="row">

        <div class="col-xl-8 col-lg-7 order-lg-last pl-50 pl-md-15 pl-xs-15">
          <div class="content-style-one">
            <h2>Privacy Policy</h2>
            <p><strong>Last Updated: October 2026</strong></p>
            <p>
              Novarix Tech Pvt Ltd ("Novarix", "we", "our", or "us") operates the Norbix Enterprise software platform, including our website (novarix.tech) and mobile applications: <strong>NovaHRM</strong>, <strong>NovaFLEET</strong>, and <strong>NovaCONNECTS</strong>. We are committed to protecting your personal information and your right to privacy.
            </p>

            <h3>1. Information We Collect</h3>
            <p>
              We collect information that you provide directly to us or that is automatically collected when using our applications and services:
            </p>
            <ul>
              <li><strong>Account and Profile Information:</strong> Name, email address, phone number, organization/tenant affiliation, employee ID, role, and login credentials.</li>
              <li><strong>Device and Technical Data:</strong> Device model, operating system version, unique device identifiers, IP address, and Firebase Cloud Messaging (FCM) push notification tokens.</li>
              <li><strong>Camera and Biometric Data:</strong> With user permission, our apps may access the device camera to support facial attendance verification and profile photo capture. Face data is strictly used for biometric verification within your organization and is not sold or shared with external parties.</li>
            </ul>

            <div class="alert alert-info mt-20 mb-20" style="background: #f0f7ff; border-left: 4px solid #0066cc; padding: 15px; border-radius: 4px;">
              <h4 style="color: #004499; margin-top: 0;">2. Location Information (Foreground and Background Location)</h4>
              <p>
                Certain enterprise features across our applications require access to your device's geographical location:
              </p>
              <ul>
                <li><strong>Precise and Approximate Location:</strong> We collect precise (GPS-based) and approximate (network-based) location coordinates when permitted by the user.</li>
                <li><strong>NovaHRM (Attendance & Shift Geofencing):</strong> Location data is accessed to verify that employee check-in and check-out occur within designated workplace boundaries (geofencing) and to validate duty shifts.</li>
                <li><strong>NovaFLEET (Trip & Vehicle Tracking):</strong> Location data is used to provide real-time vehicle positioning, route navigation, live transit updates, and driver safety monitoring during active assignments.</li>
                <li><strong>Background Location Disclosure:</strong> 
                  <em>Our applications (including NovaHRM and NovaFLEET) may access and collect location data even when the app is closed or not in active use, specifically while an employee is on an active duty shift or while a vehicle/driver is executing an assigned trip.</em> This background collection is necessary to ensure continuous trip tracking, accurate route mileage calculation, and shift safety compliance.
                </li>
              </ul>
              <p style="margin-bottom: 0;">
                <strong>No Location Sharing for Ads:</strong> Location data is never used for advertising, behavioral profiling, or sold to third-party data brokers. It is transmitted solely to your enterprise tenant's secure cloud environment for organizational workforce and fleet management.
              </p>
            </div>

            <h3>3. How We Use Collected Data</h3>
            <p>We use the collected information for specific, legitimate enterprise operational purposes:</p>
            <ul>
              <li>To provide, operate, and maintain our enterprise resource planning and workforce management services.</li>
              <li>To process attendance records, calculate work hours, and ensure accurate shift accounting.</li>
              <li>To track fleet operations, optimize vehicle dispatching, and verify delivery/transport routes.</li>
              <li>To send critical operational alerts, task notifications, and incoming call alerts via push notifications.</li>
              <li>To detect and prevent fraudulent access, unauthorized usage, and device integrity violations.</li>
            </ul>

            <h3>4. Data Sharing and Third-Party Disclosures</h3>
            <p>
              We do not sell, rent, or trade your personal information. We only share information with:
            </p>
            <ul>
              <li><strong>Your Employer / Organization:</strong> All operational data, attendance records, and location logs are shared with your organization's authorized enterprise administrators.</li>
              <li><strong>Infrastructure Service Providers:</strong> Trusted third-party cloud infrastructure and backend providers (e.g., Google Cloud, Firebase for push notifications and messaging) operating under strict data protection agreements.</li>
              <li><strong>Legal Compliance:</strong> When required by applicable law, regulation, legal process, or governmental request.</li>
            </ul>

            <h3>5. Data Security and Retention</h3>
            <p>
              We implement industry-standard administrative, physical, and technical safeguards (including HTTPS/TLS 1.2+ encryption for data in transit and AES encryption for data at rest) to protect your personal and location data from unauthorized access, disclosure, or alteration.
            </p>
            <p>
              We retain personal data and location logs only for as long as necessary to fulfill the organizational purposes outlined in our enterprise agreement with your tenant or as mandated by statutory compliance requirements.
            </p>

            <h3>6. Your Controls and Permissions</h3>
            <p>
              You maintain control over your device permissions:
            </p>
            <ul>
              <li><strong>Location Permissions:</strong> You can grant, deny, or revoke location access at any time through your device's <em>Settings &gt; Apps &gt; [App Name] &gt; Permissions &gt; Location</em>. Choosing "Allow only while using the app" or "Don't allow" may restrict certain background tracking or geofenced attendance features.</li>
              <li><strong>Camera and Notifications:</strong> You can similarly manage camera access and push notification preferences via your device settings.</li>
            </ul>

            <h3>7. Children's Privacy</h3>
            <p>
              Our enterprise applications are designed for professional and educational institutional use and are not directed to children under 13 years of age.
            </p>

            <h3>8. Changes to This Privacy Policy</h3>
            <p>
              We may update this Privacy Policy from time to time. Updates will be reflected on this page with an updated "Last Updated" date.
            </p>

            <h3>9. Contact Us</h3>
            <p>
              If you have any questions or concerns regarding this Privacy Policy or our data practices, please contact us at:
            </p>
            <p>
              <strong>Novarix Tech Pvt Ltd</strong><br>
              Email: <a href="mailto:support@novarix.tech">support@novarix.tech</a><br>
              Website: <a href="https://novarix.tech" target="_blank" rel="noopener">https://novarix.tech</a>
            </p>
          </div>
        </div>

        <div class="col-xl-4 col-lg-5 mt-md-120 mt-xs-50 services-sidebar">
          <div class="single-widget services-list-widget">
            <h4 class="widget-title">Policies</h4>
            <div class="content">
              <ul>
                <li routerLinkActive="current-item"><a routerLink="/policies/terms-and-conditions">Terms and conditions</a></li>
                <li routerLinkActive="current-item"><a routerLink="/policies/privacy-policy">Privacy Policy</a></li>
                <li routerLinkActive="current-item"><a routerLink="/policies/refund-policy">Refund Policy</a></li>
                <li routerLinkActive="current-item"><a routerLink="/policies/cancellation-policy">Cancellation Policy</a></li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
